export const TEST_USAGE_COLORS = [
  "#0063C7",
  "#2563EB",
  "#60A5FA",
  "#7C3AED",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#EC4899",
  "#6B7280",
  "#14B8A6",
];

export const buildTestUsageCounts = (patients) => {
  const counts = new Map();

  for (const patient of patients) {
    for (const test of patient.tests || []) {
      const testName = test.testName?.trim() || "Sin nombre";
      counts.set(testName, (counts.get(testName) || 0) + 1);
    }
  }

  const items = [...counts.entries()]
    .map(([testName, count]) => ({ testName, count }))
    .sort((a, b) => b.count - a.count);

  const total = items.reduce((sum, item) => sum + item.count, 0);

  return {
    total,
    items: items.map((item, index) => ({
      ...item,
      color: TEST_USAGE_COLORS[index % TEST_USAGE_COLORS.length],
      percentage: total > 0 ? Math.round((item.count / total) * 100) : 0,
    })),
  };
};
